import React from 'react';

const ContactBanner = () =>{
    return (
        <>
        <div className='cadContactBanner cadAboutBanner'>
            <img 
            src="/assets/contact-us-banner.webp"
            alt="contact-us-banner" />
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1>Contact</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default ContactBanner;